// import React from "react";
// import "../assets/styles/Card.css";

// const Card = ({ text, number, icon, onClick }) => {
//   return (
//     <div
//       className="cardStyle"
//       onClick={onClick}               // make whole card clickable
//       style={{ cursor: onClick ? "pointer" : "default" }}
//     >
//       <div className="cardStyle2">
//         <span className="cardText" style={{ fontSize: "22px" }}>
//           <span style={{ paddingLeft: "15px" }}>{text} </span>
//         </span>
//       </div>
//       <div className="textIcon">
//         <div className="cardText">{icon}</div>
//         <div className="cardText">
//           <span style={{ paddingLeft: "15px" }}>{number}</span>
//         </div>
//       </div>
//     </div>
//   );
// };



// export default Card;

import React from "react";
import "../assets/styles/Card.css";

const Card = ({ text, number, icon, onClick }) => {
  return (
    <div
      className="cardStyle"
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {/* Top text row */}
      <div className="cardStyle2">
        <span
          className="cardText"
          style={{ fontSize: "22px", display: "block", textAlign: "left" }}
        >
          <span style={{ paddingLeft: "15px" }}>{text}</span>
        </span>
      </div>

      {/* Bottom row: number left, icon right */}
      <div
        className="textIcon"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          className="cardText"
          style={{ textAlign: "left", paddingLeft: "15px" }}
        >
          {number}
        </div>
        <div
          className="cardText"
          style={{ textAlign: "right", paddingRight: "15px" }}
        >
          {icon}
        </div>
      </div>
    </div >
  );
};

export default Card;
